import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConsentsAndDeclarationsType } from '../api/types';

const useConsentTypeOptions = () => {
    const { t } = useTranslation('consentsAndDeclarations');

    return useMemo(() => {
        const consentTypeOptions = [
            {
                value: ConsentsAndDeclarationsType.Text,
                label: t('consentsAndDeclarations:options.consentTypes.text'),
            },
            {
                value: ConsentsAndDeclarationsType.Checkbox,
                label: t('consentsAndDeclarations:options.consentTypes.checkbox'),
            },
            {
                value: ConsentsAndDeclarationsType.Marketing,
                label: t('consentsAndDeclarations:options.consentTypes.marketing'),
            },
        ];

        return consentTypeOptions;
    }, [t]);
};

export default useConsentTypeOptions;
